import { Box, Button, Typography } from '@mui/material';

import QuestionOption from './Questionnaires/QuestionOption';
import AnswerCard from './AnswerCard';

import { IQuestionProps } from '../../constants/types';
import { QUESTION_TYPE } from '../../constants';

const Question: React.FC<IQuestionProps> = ({
  question,
  shouldRenderSubQuestion,
  disableSubmit,
  setAnswer,
  handleContinue,
  setMultiTextAnswer,
}) => {
  const {
    answer,
    options,
    condition,
    question_type: questionType,
    sub_questions: subQuestions,
    question: questionText,
  } = question;

  const isMultiText =
    questionType === QUESTION_TYPE.MULTITEXT ||
    condition === QUESTION_TYPE.MULTITEXT;

  const handleDeleteAnswer = (index: number) => {
    if (Array.isArray(answer)) {
      const updatedAnswers = [...answer];
      updatedAnswers.splice(index, 1);
      setMultiTextAnswer(updatedAnswers);
    }
  };

  const renderSubQuestion = () => {
    if (!shouldRenderSubQuestion) return null;

    const filteredSubQuestion = subQuestions.find(
      (subQuestion) =>
        subQuestion.condition === 'All' || subQuestion.condition === answer
    );

    if (filteredSubQuestion && !filteredSubQuestion?.question) {
      return (
        <QuestionOption
          value={filteredSubQuestion.answer}
          options={filteredSubQuestion.options}
          questionType={filteredSubQuestion.question_type}
          setAnswer={(key) => setAnswer(key, true)}
          childQuestion={true}
          question={filteredSubQuestion}
        />
      );
    }
    return null;
  };

  return (
    <Box
      data-testid="question-component"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        flexGrow: 1,
      }}
    >
      <Typography variant="h5" mb={7}>
        {questionText}
      </Typography>

      {Array.isArray(answer) &&
        isMultiText &&
        answer.map((textAnswer, index) => (
          <AnswerCard
            key={index}
            answerText={textAnswer}
            index={index}
            onDelete={handleDeleteAnswer}
          />
        ))}

      <QuestionOption
        value={answer}
        options={options}
        questionType={questionType}
        question={question}
        setAnswer={(key) => setAnswer(key, false)}
      />

      {renderSubQuestion()}

      <Button
        disabled={disableSubmit}
        variant="contained"
        color="primary"
        type="submit"
        fullWidth
        sx={{ mt: 'auto' }}
        onClick={handleContinue}
      >
        Continue
      </Button>
    </Box>
  );
};

export default Question;
